<template>
    <v-container fluid >
        <v-row align="center"
               justify="center">
            <v-col xl="6">
                <v-card
                        raised
                >
                    <v-card-title class="justify-center display-3">
                        Ooops!!!
                    </v-card-title>

                    <v-card-text class="display-1">
                        Sorry that you have reach here. Select an option below
                    </v-card-text>

                    <v-card-actions class="justify-center">
                        <v-btn  otlined
                                to="/home">
                            <v-icon left dark>home</v-icon>
                            Home
                        </v-btn>
                        <v-btn  otlined
                                @click="goBack">
                            <v-icon left dark>mdi-backup-restore</v-icon>
                            Back
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>


    export default {
        name: "PageNotFound",
        methods:{
            goBack(){
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>